export enum DeliveryCarrierEnum {
  Dpd = 'dpd'
}
